<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0 ml-2">บทบาท</span>
      <div style="display: flex">
        <v-text-field
          v-model="search"
          label="ค้นหา"
          prepend-inner-icon="mdi-magnify"
          clearable
          flat
          solo
          dense
          hide-details
          style="width: 200px; padding: 0 5px"
        ></v-text-field>
        <v-btn
          :disabled="uiCtrl && !uiCtrl.isEnable('btn:::role:create')"
          style="margin-top: 1px"
          color="primary"
          @click="handleAddRoleForm"
        >
          <v-icon small left>mdi-plus</v-icon>เพิ่มบทบาท
        </v-btn>
      </div>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="userRoles"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
    >
      <template v-slot:item.count_employees="{ item }">
        <v-btn text @click="handleEmployeeListInRole(item.role_uuid)">
          {{ item.count_employees }}
        </v-btn>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          :disabled="uiCtrl && !uiCtrl.isEnable('row:::role:get')"
          small
          class="mr-2"
          @click="handleEditRoleForm(item)"
        >
          {{ item.is_default ? 'mdi-eye-outline' : 'mdi-pencil' }}
        </v-icon>
        <v-icon
          :disabled="uiCtrl && !uiCtrl.isEnable('btn:::role:delete')"
          v-if="!item.is_default"
          small
          @click="deleteUserRoleItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <EmployeeListInRoleDialog
      :dialog="employeeListInRoleDialog"
      @onCloseEmployeeListInRoleDialog="handleCloseEmployeeListInRoleDialog"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'
import EmployeeListInRoleDialog from '@/components/EmployeeListInRoleDialog.vue'

export default {
  components: {
    ConfirmDialog,
    EmployeeListInRoleDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['title'],
      sortDesc: [false],
      loading: true,
      search: '',
      headers: [
        {
          text: 'ชื่อบทบาท (Role)',
          align: 'start',
          value: 'title',
          width: 320,
        },
        { text: 'คำอธิบาย', value: 'description' },
        {
          text: 'จำนวนผู้ใช้งาน',
          align: 'start',
          value: 'count_employees',
          width: 180,
        },
        {
          text: 'Actions',
          align: 'right',
          value: 'actions',
          width: 90,
          sortable: false,
        },
      ],
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      employeeListInRoleDialog: false,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    userRoles() {
      return this.$store.state.userRole.userRoles
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'บทบาท',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchUserRoles: 'userRole/fetchUserRoles',
      fetchEmployeeListInRole: 'userRole/fetchEmployeeListInRole',
      deleteUserRole: 'userRole/deleteUserRole',
    }),

    async handleEmployeeListInRole(role_uuid) {
      try {
        this.$store.state.loading = true

        const payload = {
          company_uuid: this.$store.state.authentication.company.company_uuid,
          role_uuid,
        }

        await this.fetchEmployeeListInRole(payload)

        this.employeeListInRoleDialog = true
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },

    handleCloseEmployeeListInRoleDialog() {
      this.loadData()
      this.employeeListInRoleDialog = false
    },

    deleteUserRoleItem(userRole) {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบบทบาท',
        value: userRole.title,
        item: userRole,
      }
    },

    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },

    submitConfirmDialogDelete(userRole) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.deleteUserRole({
        company_uuid,
        role_uuid: userRole.role_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },

    handleAddRoleForm() {
      this.$router.push({ name: 'UserRoleAdd' })
    },

    handleEditRoleForm(userRole) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::role:get')) {
        this.dialogForbidden = true
        return
      }

      this.$router.push({
        name: 'UserRoleEdit',
        params: { role_uuid: userRole.role_uuid },
      })
    },

    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      this.fetchUserRoles(company_uuid)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
  },
}
</script>
